import React, { useState } from 'react';
import './Explore4.css';
import Explore5 from './Explore5';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BookExpert from './BookExpert';
import Login from '../Login/Login';

const Explore4 = () => {
  const [selectedOption, setSelectedOption] = useState('I struggle with building or maintaining relationships');
  const [showExplore5, setShowExplore5] = useState(false);
  const [showBookExpert, setShowBookExpert] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    // Chuyển sang Explore 5 sau khi chọn
    setTimeout(() => {
      setShowExplore5(true);
    }, 300);
  };

  // If user clicked Organizations, show BookExpert
  if (showBookExpert) {
    return <BookExpert />;
  }

  // If user clicked Login, show Login page
  if (showLogin) {
    return <Login />;
  }

  // Nếu đã chọn option, hiển thị Explore5
  if (showExplore5) {
    return <Explore5 />;
  }

  const reasonOptions = [
    'My mood is interfering with my daily routine such as sleeping, eating, job/school performance',
    'I\'ve been feeling depressed',
    'I feel anxious or overwhelmed',
    'I struggle with building or maintaining relationships',
    'I can\'t find purpose and meaning in my life',
    'I am grieving',
    'I have experienced trauma',
    'I need to talk through a specific challenge',
    'I want to gain self confidence'
  ];

  return (
    <div className="explore4-container page-with-header">
      <Header 
        showBookExpert={showBookExpert} 
        setShowBookExpert={setShowBookExpert}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
      />

      {/* Main Content */}
      <div className="main-content">
        <div className="white-container">
          <div className="content-wrapper">
            <h1 className="main-title">Help us get to know you</h1>
            <p className="subtitle">Please answer the following questions.</p>
            
            <div className="question-section">
              <h2 className="question">
                What led you to Learning to Mend today?
              </h2>
              
              <div className="options-container">
                {reasonOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Chat Icon */}
      <div className="chat-icon">
        <div className="monitor">
          <div className="screen">
            <div className="face">
              <div className="eyes">
                <span className="eye">"</span>
                <span className="eye">"</span>
              </div>
              <div className="mouth">)</div>
            </div>
          </div>
          <div className="base"></div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Explore4;

